export const stockSharesISAOptions = [
  { labelText: 'No', id: 'false' },
  { labelText: 'Yes', id: 'true' }
];
export const transferRadioOptions = [
  [
    {
      labelText: 'Account number and sort code',
      id: 'ACCOUNT_NUMBER_SORT_CODE'
    }
  ],
  [
    {
      labelText: 'Account reference',
      id: 'ACCOUNT_REFERENCE'
    }
  ]
];
export const existingISAOptions = [
  [
    {
      labelText: 'Transfer the full balance and close the account',
      id: 'Full balance'
    }
  ],
  [
    {
      labelText: 'Transfer only the current tax year subscriptions',
      id: 'Current year subscriptions only'
    }
  ],
  [
    {
      labelText: 'Transfer a chosen amount',
      id: 'Specific Balance'
    }
  ]
];
export const transferPeriodOptions = [
  {
    labelText:
      'Wait for the full notice period to end or until the fixed term expires - I confirm this date is within the next six weeks.',
    id: 'Full Notice Period'
  },
  {
    labelText:
      'Make the transfer as soon as possible - I will accept any loss of interest or exit charges that may apply.',
    id: 'Transfer Immediately'
  }
];
